/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import FormattedRelativeWrapper from 'app/components/common/FormattedRelativeWrapper.jsx';
import ConfirmationModal from 'app/components/Subscription/ConfirmationModal.jsx';
import * as _ from 'underscore';
import Loading from 'app/components/common/Loading.jsx';
import { Link } from 'react-router-dom';
import { Breakpoint } from 'react-socks';
import CurrentSubscriptionDisplay from 'app/components/Subscription/CurrentSubscriptionDisplay.jsx';
import AddOnWidget from 'app/components/Subscription/AddOnWidget.jsx';
import AddTweetModal from 'app/components/Subscription/AddTweetModal.jsx';
import SubscriptionPage from '@/shadcn/components/account/SubscriptionPage/SubscriptionPage.tsx';

class UpgradePricing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            add_on_social: 0,
            add_on_posts_1: 0,
            term: this.props.plans.current.planTerm,
            addOnError: '',
            addOnUpgrade: true,
            isEditingPlan: false,
            lastUpdateAction: ''
        };

        this.setAddOns = this.setAddOns.bind(this);
        this.onClickSocialAddOns = this.onClickSocialAddOns.bind(this);
        this.subscriptionUpdate = this.subscriptionUpdate.bind(this);
        this.subscriptionConfirm = this.subscriptionConfirm.bind(this);
        this.addOnCancel = this.addOnCancel.bind(this);

    }

    componentDidMount() {

        this.setAddOns(this.props);

        if (dataLayer) {
            dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 1, 'option': 'Upgrade'}
                    }
                }
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if ((_.isEmpty(prevProps.plans.current) && !_.isEmpty(this.props.plans.current)) &&
            this.props.plans.current.addOns &&
            this.props.plans.current.addOns != prevProps.plans.current.addOns ||
            !_.isEmpty(this.props.errors)) {
            this.setAddOns(this.props);
        }

        if (!_.isEmpty(this.props.plans.current)) {
            let isEditingPlan = false,
                socialAddOns = 0,
                postAddOns = 0;

            if (this.props.plans.current.addOns.add_on_social !== undefined) {
                socialAddOns = parseInt(this.props.plans.current.addOns.add_on_social.qty, 10);
            }

            if (this.props.plans.current.addOns && this.props.plans.current.addOns.add_on_posts_1 !== undefined) {
                postAddOns = parseInt(this.props.plans.current.addOns.add_on_posts_1.qty, 10);
            }

            if (this.state.add_on_social !== socialAddOns) {
                isEditingPlan = true;
            }

            if (this.state.isEditingPlan !== isEditingPlan) {
                this.setState({
                    isEditingPlan
                });
            }

        }

    }

    setAddOns(props) {
        let addOns = 0,
            addOnPosting = 0;

        if (props.plans.current.addOns && props.plans.current.addOns.add_on_social) {
            addOns = parseInt(props.plans.current.addOns.add_on_social.qty, 10);
        }
        if (addOns !== this.state.add_on_social) {
            this.setState({
                add_on_social: addOns
            });
        }

        if (props.plans.current.addOns && props.plans.current.addOns.add_on_posts_1) {
            addOnPosting = parseInt(props.plans.current.addOns.add_on_posts_1.qty, 10);
        }
        if (addOnPosting != this.state.add_on_posts_1) {
            this.setState({
                add_on_posts_1: addOnPosting
            });
        }

    }

    onClickSocialAddOns(qty) {

        let nextQty = qty,
            newLimits = null,
            currentInputs = parseInt(this.props.user.perms.perms.hardLimitInputs, 10) - this.props.user.perms.resources.inputsAvailable,
            currentOutputs = parseInt(this.props.user.perms.perms.hardLimitOutputs, 10) - this.props.user.perms.resources.outputsAvailable,
            addOnUpgrade = this.state.addOnUpgrade,
            constants = this.props.app.config.constants;

        if ((nextQty < this.props.plans.current?.addOns?.add_on_social?.qty)) {
            addOnUpgrade = false;
            newLimits = this.props.calculateAddOns([{
                addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
                quantity: nextQty
            }]);
            if ((newLimits.inputs < currentInputs) || (newLimits.outputs < currentOutputs)) {
                this.setState({
                    addOnError: "Your usage would exceed the new limits with fewer add-ons. Turn off or remove feeds and socials to fit the limits."
                });
                return;
            }
        }

        if (nextQty >= 0) {
            this.setState({
                addOnError: '',
                add_on_social: nextQty,
                addOnUpgrade
            });
        }

    }

    subscriptionUpdate(addOnType) {
        let constants = this.props.app.config.constants,
            addOnUpdates = {},
            lastUpdateAction = '';

        if (addOnType.indexOf(constants.SUBSCRIPTION_ADDON_SOCIALS) !== -1) {
            addOnUpdates.add_on_social = this.state.add_on_social;
            lastUpdateAction = 'socials';
        }
        if (addOnType.indexOf(constants.SUBSCRIPTION_ADDON_POSTS_1) !== -1) {
            addOnUpdates.add_on_posts_1 = this.state.add_on_posts_1;
            lastUpdateAction = 'posts';
        }

        if (Object.keys(addOnUpdates).length) {
            this.setState({
                lastUpdateAction
            }, () => {
                this.props.onAddOnUpdate(addOnUpdates);
            })
        }

    }

    subscriptionConfirm(type) {

        let constants = this.props.app.config.constants,
            subscriptionInfo = {
                subscription: this.props.plans.current,
                addOns: {}
            },
            addOns = [],
            addOnType = [],
            newLimits = {},
            confirmation = null,
            socialAddOns = 0,
            extraPosts = 0;

        if (_.isObject(this.props.plans.current.addOns.add_on_social)) {
            socialAddOns = this.props.plans.current.addOns.add_on_social.qty;
        }

        if (_.isObject(this.props.plans.current.addOns.add_on_posts_1)) {
            extraPosts = this.props.plans.current.addOns.add_on_posts_1.qty;
        }

        if (type === "add_on_social") {
            subscriptionInfo.addOns.add_on_social = this.state.add_on_social;
            addOns.push({
                addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
                quantity: this.state.add_on_social
            });
            addOnType.push(constants.SUBSCRIPTION_ADDON_SOCIALS);
        }

        if (type === "add_on_posts_1") {
            subscriptionInfo.addOns.add_on_posts_1 = this.state.add_on_posts_1;
            addOns.push({
                addOn: constants.SUBSCRIPTION_ADDON_POSTS_1,
                quantity: this.state.add_on_posts_1
            });
            addOnType.push(constants.SUBSCRIPTION_ADDON_POSTS_1);
        }

        newLimits = this.props.calculateAddOns(addOns);

        confirmation = (
            <ConfirmationModal
                {...this.props}
                confirmationType="addonchange"
                confirmationAction={this.subscriptionUpdate}
                subscription={subscriptionInfo}
                newLimits={newLimits}
                addOnType={addOnType}
                planLevel={this.props.plans.current.planLevel}
                planTerm={this.props.plans.current.planTerm}
                onConfirmationCancel={() => {
                    this.setState({
                        add_on_posts_1: extraPosts,
                        add_on_social: socialAddOns,
                        isEditingPlan: false
                    });
                }} />
        );

        if (gtag) {
            let promoData = this.props.getPersistedData('gaPromo');

            gtag('event', 'begin_checkout', {
                currency: 'USD',
                value: 1.0,
                items: [{
                    item_id: 'dlvrit_1',
                    item_name: 'dlvr.it premium plan',
                    item_variant: (this.state.addOnUpgrade) ? 'Purchase Add-On' : 'Remove Add-On',
                    price: 1.0,
                    quantity: 1,
                    promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                    promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                }],

            });

            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: (this.state.addOnUpgrade) ? 'Purchase Add-On' : 'Remove Add-On',
                    event_data: {
                        promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                        promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                    }
                });
            }

        }

        this.props.addModal(confirmation);

    }

    addOnCancel(type) {
        let previousValue = 0;

        if (this.props.plans.current?.addOns[type]?.qty) {
            previousValue = this.props.plans.current?.addOns[type]?.qty
        }

        let state = Object.assign({}, this.state);

        state[type] = previousValue;
        state.addOnError = '';

        this.setState(state);

    }

    render() {
        let constants = this.props.app.config.constants,
            currentLimits = {},
            limits = this.props.calculateAddOns([{
                addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
                quantity: this.state.add_on_social
            },
            {
                addOn: constants.SUBSCRIPTION_ADDON_POSTS_1,
                quantity: this.state.add_on_posts_1
            }]),
            planLabel = '',
            planPriceLabel = '',
            today = new Date(),
            trialEnd = null,
            formattedDate = null,
            savingsPct = 0,
            savingsTotal = 0,
            activeCoupons = [];

        if (_.isEmpty(this.props.plans.current) || _.isEmpty(this.props.plans.details[this.props.user.detail.pubLevel]) || this.props.app.loading.SUB_FETCH) {
            return (
                <Loading />
            );
        }

        currentLimits = this.props.calculateAddOns();

        if (this.props.plans.current.coupons !== undefined && this.props.plans.current.coupons.length) {
            for (let i = 0; i < this.props.plans.current.coupons.length; ++i) {
                let lineDiscount = null,
                    coupon = this.props.plans.current.coupons[i],
                    itemClass = 'active-coupon nunito-dlvr',
                    couponStart = null,
                    couponExpires = null;

                couponStart = moment(coupon.createdAt);
                if (coupon.temporalUnit !== undefined && coupon.temporalAmount !== undefined) {
                    couponExpires = couponStart.add(coupon.temporalAmount, coupon.temporalUnit).format("MMM D, YYYY");
                }

                if (coupon.type === 'fixed') {
                    lineDiscount = `$${coupon.currencies[0].amount}`;
                } else if (coupon.type === 'percent') {
                    lineDiscount = `${coupon.percent}%`;
                } else {
                    continue;
                }

                activeCoupons.push({
                    code: coupon.code,
                    discount: lineDiscount,
                    expires: couponExpires
                });
            }
        }

        let annualPrice = this.props.plans.details[this.props.plans.current.planLevel].price[constants.SUBSCRIPTION_TERM_ANNUAL],
            monthlyPrice = this.props.plans.details[this.props.plans.current.planLevel].price[constants.SUBSCRIPTION_TERM_MONTHLY];

        if (!this.props.isProUser()) {
            let monthlyAnnual = monthlyPrice * 12;

            savingsTotal = (monthlyAnnual - annualPrice).toFixed(2);
            savingsPct = ((savingsTotal / monthlyAnnual) * 100).toFixed(0);

        } else {
            savingsTotal = 60;
            savingsPct = 33;

        }

        planLabel = 'dlvr.it ' + this.props.plans.details[this.props.user.detail.pubLevel].label;

        planPriceLabel = <FormattedNumber value={limits.price} style="currency" currency="USD"/>;


        if (this.props.errors !== null) {
            // errorBlock = (
            //     <div className="subscription-error">
            //         We couldn't complete your transaction. Please <Link to="/account/billing?update=true">update your billing information.</Link>
            //     </div>
            // );
        }



        let pendingChange = null;
        if (this.props.user.detail.postAddons > 0) {
            if (this.props.user.detail.postAddons * 100 !== parseInt(this.props.user.perms.perms.add_on_posts_1)) {
                pendingChange = ". Changes to X Posts will take effect then.";
            }
        }

        let subscriptionPause = null;
        if (this.props.user.plan.pauseStart && this.props.user.plan.pauseEnd) {
            subscriptionPause = {
                start: new Date(this.props.user.plan.pauseStart),
                end: new Date(this.props.user.plan.pauseEnd),
                cycles: this.props.user.plan.pauseCycles
            }
        } else if (this.props.user.plan.status !== undefined && this.props.user.plan.status.canceled === false) {
            // renewalBlock = (
            //     <div className="renewal-notice">
            //         (Renews {moment(this.props.plans.current.nextBilling).format("MMM D, YYYY")}{pendingChange})
            //     </div>
            // );
        }

        let postLimit = parseInt(this.props.user.perms.perms.postLimit);
        if (postLimit === 0) {
            postLimit = "Unlimited";
        }

        return (
            <div className="subscription-info">
                <div className="tw-root">
                    <SubscriptionPage
                        constants={this.props.app.config.constants}
                        plan={this.props.user.plan}
                        currentLimits={currentLimits}
                        nextLimits={limits}
                        planDetails={this.props.plans.details[this.props.user.detail.pubLevel]}
                        currentAddOns={{
                            add_on_posts_1: this.state.add_on_posts_1,
                            add_on_social: this.state.add_on_social
                        }}
                        planName={planLabel}
                        planPrice={planPriceLabel}
                        postLimit={postLimit}
                        onClickSocialAddOns={this.onClickSocialAddOns}
                        onClickXPosts={(qty) => {
                            this.setState({
                                add_on_posts_1: qty
                            })
                        }}
                        onConfirmAddOn={this.subscriptionConfirm}
                        onCancelAddOn={this.addOnCancel}
                        cancelPlan={this.props.cancelPlan}
                        restartPlan={this.props.restartPlan}
                        savingsPct={savingsPct}
                        savingsTotal={savingsTotal}
                        activeCoupons={activeCoupons}
                        subscriptionPause={subscriptionPause}
                        comparePlans={(e) => {
                            e.preventDefault();
                            this.props.router.navigate("/account/subscription/compare")
                        }}
                        addOnError={this.state.addOnError}
                        setRequestParams={this.props.setRequestParams}
                        promoClick={this.props.promoClick}
                        changeTerm={this.props.changeTerm}
                        resumeSubscription={() => {
                            this.props.pauseSubscription({
                                duration: 0
                            });
                        }}
                    />
                </div>
            </div>
        );
    }

};

UpgradePricing.displayName = "UpgradePricing";

UpgradePricing.propTypes = {
    userPerms: PropTypes.object,
    currentSubscription: PropTypes.object,
    planDetails: PropTypes.object,
    onAddOnUpdate: PropTypes.func,
    subscriptionUpdate: PropTypes.func,
    errors: PropTypes.object
};

UpgradePricing.defaultProps = {
    userPerms: {},
    currentSubscription: {},
    planDetails: {},
    onAddOnUpdate: null,
    subscriptionUpdate: null,
    errors: null
};

export default UpgradePricing;
